import actions from "@/store/modules/microsites/actions";
import { mutations, state } from "@/store/modules/microsites/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
